import { useState, useEffect } from 'react';

export const useGoogleAnalytics = (measurementId: string) => {
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);

  useEffect(() => {
    // Check initial consent status
    const checkConsent = () => {
      const analyticsConsent = localStorage.getItem('analytics-consent');
      const cookieConsent = localStorage.getItem('cookie-consent');
      
      // Enable analytics if explicitly accepted or if no cookie banner has been shown yet
      const shouldEnable = analyticsConsent === 'accepted' || 
                          (cookieConsent === 'accepted' && analyticsConsent !== 'declined');
      
      setAnalyticsEnabled(shouldEnable);
    };

    checkConsent();

    // Listen for consent changes
    const handleConsentAccepted = () => {
      setAnalyticsEnabled(true);
    };

    const handleConsentDeclined = () => {
      setAnalyticsEnabled(false);
      
      // Disable GA tracking if it was previously enabled
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'denied'
        });
      }
    };

    window.addEventListener('cookieConsentAccepted', handleConsentAccepted);
    window.addEventListener('cookieConsentDeclined', handleConsentDeclined);

    return () => {
      window.removeEventListener('cookieConsentAccepted', handleConsentAccepted);
      window.removeEventListener('cookieConsentDeclined', handleConsentDeclined);
    };
  }, []);

  return { analyticsEnabled };
};